export const SERVICE_LINES = [
  { value: "offset", label: "Offset" }, { value: "digital", label: "Digital" }, { value: "large_format", label: "Large format" }, { value: "label", label: "Label / packaging" },
  { value: "souvenir", label: "Souvenir" }, { value: "finishing", label: "Finishing" }, { value: "prepress", label: "Prepress" }, { value: "screen", label: "Screen print" },
  { value: "3d_print", label: "3D print" }, { value: "trade", label: "Trade" },
];
export const lineLabel = (v) => SERVICE_LINES.find((x) => x.value === v)?.label || v;
